import type { ChatMessageSegment } from "web_myplann/Chat/Types/chatMessage";
import { getExternalUrl } from "web_myplann/Shared/Utils/getExternalUrl";

const LINK_CANDIDATE = /(?:https?:\/\/|www\.)[^\s<>"]+/gi;
const LINK = /^(?:https?:\/\/|www\.)\S+$/i;
const TRAILING_PUNCTUATION = /[.,;:!?)\]'“”’]+$/;
const ATTACHED_TO_PRECEDING = /[\p{L}\p{N}_@.\-/="']/u;

export const getChatMessageSegments = (
	content: string,
): ChatMessageSegment[] => {
	const segments: ChatMessageSegment[] = [];
	let textStart = 0;

	for (const match of content.matchAll(LINK_CANDIDATE)) {
		const start = match.index;
		const link = match[0].replace(TRAILING_PUNCTUATION, "");
		const isAttached =
			start > 0 && ATTACHED_TO_PRECEDING.test(content[start - 1]);

		if (isAttached || !LINK.test(link)) {
			continue;
		}

		if (start > textStart) {
			segments.push({
				start: textStart,
				text: content.slice(textStart, start),
			});
		}

		segments.push({
			start,
			text: link,
			href: getExternalUrl(link),
		});
		textStart = start + link.length;
	}

	if (textStart < content.length) {
		segments.push({ start: textStart, text: content.slice(textStart) });
	}

	return segments;
};
